import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-[#092826] bg-[#0d3835] text-emerald-100/90 relative overflow-hidden">
      {/* Halftone dot pattern bottom overlay like Divi Cleaner-10 */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-10 bg-[radial-gradient(#ffffff_1.5px,transparent_1.5px)] [background-size:20px_20px]"
        aria-hidden="true"
      />

      {/* Main Footer Content */}
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Column 1: Brand & Presentation */}
          <div className="space-y-4">
            <Logo variant="footer-dark" />
            <p className="text-sm text-emerald-100/75 leading-relaxed">
              Professionel rengøringsservice til private boliger, virksomheder og klinikker. Vi leverer grundig, stabil og fleksibel rengøring tilpasset dine ønsker.
            </p>
            <div className="pt-2 flex items-center gap-2 text-xs text-[#f05a28] font-medium">
              <i className="fa-regular fa-shield-check text-sm text-[#f05a28]" aria-hidden="true" />
              <span className="text-emerald-100/90">Kvalitet, ordentlighed & gode aftaler</span>
            </div>
          </div>

          {/* Column 2: Ydelser */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white font-display mb-4">
              Rengøringsydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/privat-rengoering"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Privat rengøring
                </Link>
              </li>
              <li>
                <Link
                  to="/erhvervsrengoering"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Erhvervsrengøring
                </Link>
              </li>
              <li>
                <Link
                  to="/klinik-rengoering"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  <span>Klinik rengøring</span>
                  <span className="rounded-sm bg-[#f05a28]/20 px-1.5 py-0.5 text-[10px] text-orange-200 font-medium">
                    Særlig erfaring
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/hovedrengoering"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Hovedrengøring
                </Link>
              </li>
              <li>
                <Link
                  to="/flytterengoering"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Flytterengøring
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Hurtige Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white font-display mb-4">
              Virksomheden
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Forside
                </Link>
              </li>
              <li>
                <Link
                  to="/om-os"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Om Havdrup Rengøring
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Kontakt os
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="text-emerald-100/75 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="fa-regular fa-chevron-right text-[10px] text-[#f05a28]" aria-hidden="true" />
                  Få et tilbud på rengøring
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Kontaktinformationer */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white font-display mb-4">
              Kontakt
            </h3>
            <div className="space-y-3 text-sm text-emerald-100/80">
              <div className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot mt-1 text-[#f05a28] shrink-0" aria-hidden="true" />
                <div>
                  <strong className="text-white block font-medium">Havdrup Rengøring</strong>
                  <p className="text-emerald-100/70">Sivvænget 6</p>
                  <p className="text-emerald-100/70">4622 Havdrup</p>
                </div>
              </div>

              <div className="flex items-center gap-3 pt-1">
                <i className="fa-regular fa-phone text-[#f05a28] shrink-0" aria-hidden="true" />
                <a
                  href="tel:31341632"
                  className="text-white hover:text-amber-300 transition-colors font-medium cursor-pointer"
                  aria-label="Ring på 31 34 16 32"
                >
                  <span className="no-break">31 34 16 32</span>
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-[#f05a28] shrink-0" aria-hidden="true" />
                <a
                  href="mailto:havdruprengoring@gmail.com"
                  className="text-emerald-100/90 hover:text-amber-300 transition-colors cursor-pointer"
                  aria-label="Send e-mail til havdruprengoring@gmail.com"
                >
                  <span className="no-break">havdruprengoring@gmail.com</span>
                </a>
              </div>

              <div className="mt-4 pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 rounded-xl bg-[#f05a28] px-4 py-2.5 text-xs font-semibold text-white hover:bg-[#db4d1d] transition-colors cursor-pointer"
                >
                  <span>Kontakt os for et tilbud</span>
                  <i className="fa-regular fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright & note */}
        <div className="mt-12 border-t border-emerald-900/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-emerald-100/60">
          <p>© {currentYear} Havdrup Rengøring. Alle rettigheder forbeholdes.</p>
          <p>Lokal rengøringsservice med fokus på grundighed og personlig kontakt.</p>
        </div>
      </div>
    </footer>
  )
}
